(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('ActivityDriverController', ActivityDriverController);


    ActivityDriverController.$inject = [
        '$rootScope'
    ];

    function ActivityDriverController($rootScope) {
        // jshint maxstatements:false

        var row = {
            'name': 'Coches Taller',
            'description':
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. ',
            'actions': 'editar | eliminar'
        };

        var vm = this;
        vm.gridData = [];
        vm.gridOptions = {
            columnDefs: [
                {
                    field: 'name',
                    displayName: 'Nombre',
                    resizable: true,
                    minWidth: 110,
                    maxWidth: 150,
                },
                {
                    name: 'description',
                    displayName: 'Descripción',
                    resizable: true
                },
                {
                    field: 'actions',
                    displayName: 'Acciones',
                    minWidth: 110,
                    maxWidth: 125,
                    resizable: true
                }
            ],
            data: vm.gridData,
        };

        vm.goToOrdenNueva = goToOrdenNueva;

        (function () {
            loadData();
        })();


        function loadData() {
            for (var i = 0; i < 15; i++) {
                vm.gridData.push(row);
            }
        }

        function goToOrdenNueva() {
            $rootScope.tabManager.goToOrdenes(null);
        }  
    }

})();